import { getPanelTop, popFromPanel, pushToPanel } from 'weblite-router'

// TODO: implement preventBackClick
export const addToRouter = ({ cid, closeImmediately, preventBackClick }) =>
  pushToPanel('modals', `modal/${cid}`, { closeImmediately })

export const removeFromRouter = () => popFromPanel('modals')

export const getCurrentCid = () => {
  const [cid] =
    getPanelTop('modals')
      ?.location.split('/')
      .slice(-1) || []

  return cid
}
